// PRC-029: Términos del servicio con la plantilla de lectura. Solo afirma lo
// que es verdad hoy; la redacción legal definitiva llega con PRC-012 (abogado).
import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import DocPage, { DocList, DocNote, DocP } from '../modules/pricingJourney/components/DocPage';

const UPDATED = '3 de noviembre de 2026';
const CONTACT_EMAIL = 'soporte@proapricing.ai';
// PRC-029: el titular lo añade Pablo en PRC-012.
const OWNER = '[TITULAR: lo añade Pablo en PRC-012]';

const linkSx = { color: '#7dd3fc' };

const SECTIONS = [
  {
    id: 'acuerdo',
    title: 'Acuerdo',
    content: (
      <DocP>
        Estos términos son un contrato entre la empresa que usa el servicio («el Cliente») y {OWNER} («PROA Pricing»). Al usar el servicio de análisis y recomendación de precios, el Cliente los acepta.
      </DocP>
    ),
  },
  {
    id: 'definiciones',
    title: 'Definiciones',
    content: (
      <DocList items={[
        <><b>Plataforma:</b> la aplicación PROA Pricing, con sus modelos, pantallas e integraciones.</>,
        <><b>Datos del Cliente:</b> los datos de ventas, costes, productos y clientes que el Cliente carga.</>,
        <><b>Resultados:</b> las recomendaciones de precio, previsiones y análisis que genera la Plataforma.</>,
      ]} />
    ),
  },
  {
    id: 'servicio',
    title: 'Naturaleza del servicio',
    content: (
      <>
        <DocP>La Plataforma usa modelos estadísticos que aprenden del histórico del Cliente. Sus resultados son estimaciones: PROA Pricing no garantiza que las previsiones se cumplan ni que se obtenga un margen concreto.</DocP>
        <DocP>Las decisiones de precio son siempre del Cliente. La Plataforma es una herramienta de apoyo a la decisión, no un agente comercial ni financiero.</DocP>
      </>
    ),
  },
  {
    id: 'propiedad',
    title: 'Propiedad de los datos y de la plataforma',
    content: (
      <>
        <DocP>El Cliente conserva la propiedad de sus datos. PROA Pricing no reclama ningún derecho sobre ellos.</DocP>
        <DocP>PROA Pricing conserva la propiedad de la Plataforma: su código, sus modelos base y su metodología.</DocP>
      </>
    ),
  },
  {
    id: 'confidencialidad',
    title: 'Confidencialidad y seguridad',
    content: (
      <DocP>
        Ambas partes mantienen la confidencialidad de la información que se intercambian. Cómo protegemos los datos se explica en la <RouterLink to="/privacy" style={linkSx}>Política de privacidad</RouterLink>.
      </DocP>
    ),
  },
  {
    id: 'responsabilidad',
    title: 'Limitación de responsabilidad',
    content: (
      <DocP>
        En la máxima medida que permita la ley, PROA Pricing no responde de daños indirectos, lucro cesante, pérdida de oportunidades ni depreciación de inventario derivados del uso de los resultados. Su responsabilidad total se limita a lo pagado por el Cliente en los doce meses anteriores al hecho que origine la reclamación.
      </DocP>
    ),
  },
  {
    id: 'cancelacion',
    title: 'Duración, cancelación y eliminación de datos',
    content: (
      <>
        <DocP>El acuerdo dura mientras el Cliente tenga una suscripción activa. Se puede cancelar en cualquier momento desde Mi suscripción; el acceso sigue hasta el final del periodo pagado.</DocP>
        <DocP>Cuando el servicio termina, los Datos del Cliente se eliminan de nuestros sistemas 90 días después, salvo que la ley obligue a conservarlos.</DocP>
      </>
    ),
  },
  {
    id: 'contacto',
    title: 'Contacto y jurisdicción',
    content: (
      <>
        <DocNote>
          Para notificaciones legales o dudas sobre estos términos: <a href={`mailto:${CONTACT_EMAIL}`} style={linkSx}>{CONTACT_EMAIL}</a>.
        </DocNote>
        <DocP>Para cualquier controversia, las partes se someten a los Juzgados y Tribunales de Vilagarcía de Arousa (Pontevedra).</DocP>
      </>
    ),
  },
];

const TermsPage: React.FC = () => (
  <DocPage
    eyebrow="Legal"
    title="Términos del servicio"
    updated={UPDATED}
    intro="Las condiciones de uso de PROA Pricing."
    sections={SECTIONS}
  />
);

export default TermsPage;
